export const sideBarVerifyCode = {
    AuthSidebarFillCode: "AUTH.SIDEBAR.FILL_CODE",
}